import React, { Fragment } from 'react';
import { Dialog, DialogPanel, DialogDescription, DialogTitle, Transition } from '@headlessui/react';
import Spinner from '../Spinner';

const LoadingModal = ({ open, title, message }) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog open={open} onClose={() => {}} className="relative z-50">
        <Transition.Child
          as="div"
          enter="ease-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className="fixed inset-0 bg-black/40"
        />

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center px-4 py-6">
            <Transition.Child
              as="div"
              enter="ease-out duration-150"
              enterFrom="opacity-0 translate-y-2 scale-95"
              enterTo="opacity-100 translate-y-0 scale-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100 translate-y-0 scale-100"
              leaveTo="opacity-0 translate-y-2 scale-95"
            >
              <DialogPanel className="relative w-full max-w-sm rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm">
                <div className="flex flex-col items-center gap-4">
                  <Spinner />
                  <div className="space-y-1">
                    <DialogTitle className="text-base font-semibold text-darkGrey">
                      {title}
                    </DialogTitle>
                    <DialogDescription className="text-sm leading-6 text-slateGrey">
                      {message}
                    </DialogDescription>
                  </div>
                </div>
              </DialogPanel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default LoadingModal;
